import { observer } from 'mobx-react';
import React from 'react';
import { BrowseNavigationItemSelected, BrowseNavigationItemStyle } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { range } from '@udemy/shared-utils';
import { useMobileNavStore } from '../../../hooks/use-mobile-nav-store';
import { MobileNavItem, MobileNavL1Nav, MobileNavSection, MobileNavSectionHeading } from '../mobile-nav.react-component';

/**
 * Mobile navigation for the Learn AI section.
 * Reads aiLearningNav directly from the store.
 * Always renders the L1 drawer (with id for toggle target); shows loading state when data is not ready
 * so the css-toggle can find the drawer in non-split mode.
 */
export const MobileLearnAINav = observer(({
  isSplitNavByCategoriesEnabled
}) => {
  var _navData$children;
  const mobileNavStore = useMobileNavStore();
  const navData = mobileNavStore.aiLearningNav;
  const topics = mobileNavStore.aiTopics;
  const {
    gettext
  } = useI18n();
  const isLoading = !navData || topics.size === 0;
  function handleTopicClick(topic) {
    var _topic$absolute_url;
    const context = {
      id: ((_topic$absolute_url = topic.absolute_url) === null || _topic$absolute_url === void 0 || (_topic$absolute_url = _topic$absolute_url.split('/topic/')[1]) === null || _topic$absolute_url === void 0 ? void 0 : _topic$absolute_url.replace(/\/$/, '')) || '',
      style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
      type: topic.type,
      relatedEntityId: topic.id,
      relatedEntityType: topic.type,
      uiRegion: 'mobile_nav'
    };
    Tracker.publishEvent(new BrowseNavigationItemSelected(context));
  }
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-learn-ai",
    title: isSplitNavByCategoriesEnabled ? gettext('Main Menu') : null
  }, isLoading ? /*#__PURE__*/React.createElement(MobileNavSection, null, range(5).map(i => /*#__PURE__*/React.createElement(MobileNavItem, {
    key: `learn-ai-loading-${i}`,
    loading: true
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileNavSection, null, /*#__PURE__*/React.createElement(MobileNavItem, {
    key: `mobile-learn-ai-nav-item-${navData.id}`
  }, navData.title)), (_navData$children = navData.children) === null || _navData$children === void 0 ? void 0 : _navData$children.map(subcategory => {
    const currentTopics = topics.get(subcategory.id) || [];
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: `mobile-learn-ai-subcategory-id-${subcategory.id}`
    }, /*#__PURE__*/React.createElement(MobileNavSectionHeading, null, subcategory.title), /*#__PURE__*/React.createElement(MobileNavSection, null, currentTopics.map(topic => /*#__PURE__*/React.createElement(MobileNavItem, {
      key: `mobile-learn-ai-topic-id-${topic.id}`,
      href: topic.absolute_url,
      onClick: () => handleTopicClick(topic)
    }, topic.title))));
  })));
});
//# sourceMappingURL=mobile-learn-ai-nav.react-component.js.map